import { render, staticRenderFns } from "./EmailSelectionDialog.vue?vue&type=template&id=64e24324&"
import script from "./EmailSelectionDialog.vue?vue&type=script&lang=js&"
export * from "./EmailSelectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports